module.exports = __webpack_public_path__ + "img/iconNo9.fafd80f7.png";